import {TFunction} from 'react-i18next';
import {formatDateTime} from 'i18n/localeDateFormat';
import i18n from 'i18n/i18n';
import Excel from 'exceljs';
import {
	renderHeaderXL,
	createZIPXL,
	renderDateXL,
	renderStringArrayXL,
	renderRowItemAsLinkXL,
} from './ExcelExportCommon';
import {PogisDocumentModified} from 'features/Archive/PogisDocumentPage';

interface IPOGISPage {
	(entityListItems: any[], columnNames: string[], t: TFunction): Promise<void>;
}

export const handleClickPOGISPage: IPOGISPage = async (
	entityListItems,
	columnNames,
	t,
) => {
	const arrPOGISFilt = entityListItems as PogisDocumentModified[];

	const strTrNS = 'features/pogisdocuments';
	const strTrPrefix = 'PogisDocumentsList';
	const strPageName = 'POGIS';
	const columns = columnNames.map(x => {
		return {name: x, filterButton: true};
	});
	const arrColWidth = [10, 40, 40, 40, 80, 40, ...new Array(11).fill(25)];
	const workbook = new Excel.Workbook();
	const sheet = workbook.addWorksheet('TRACE_' + strPageName);
	renderHeaderXL(workbook, sheet, arrColWidth, strPageName, t);

	let intRowCount = 4;
	let row = sheet.getRow(intRowCount);
	row.font = {
		bold: true,
		name: 'Porsche Next TT',
		size: 10,
		color: {argb: 'FFFFFFFF'},
	};
	sheet.addTable({
		name: 'tablePOGIS',
		ref: 'B' + String(intRowCount),
		style: {
			showRowStripes: true,
		},
		columns,
		rows: [],
	});
	intRowCount++;

	const table = sheet.getTable('tablePOGIS');
	for (let ii = 0; ii < arrPOGISFilt.length; ii++) {
		row = sheet.getRow(intRowCount);
		row.alignment = {wrapText: true, vertical: 'top'};
		table.addRow([
			arrPOGISFilt[ii].pogisId,
			renderStringArrayXL(arrPOGISFilt[ii].keywords),
			renderStringArrayXL(arrPOGISFilt[ii].markets),
			renderStringArrayXL(arrPOGISFilt[ii].standards),
			arrPOGISFilt[ii].shortInfo,
			'',

			renderDateXL(arrPOGISFilt[ii].effectiveDate),
			renderDateXL(arrPOGISFilt[ii].ntDate),
			renderDateXL(arrPOGISFilt[ii].nfDate),
			renderDateXL(arrPOGISFilt[ii].modelYear),
			renderStringArrayXL(
				(arrPOGISFilt[ii].otherDates ?? []).map(
					x => `${renderDateXL(x.date)} (${x.dateType})`,
				),
			),
			arrPOGISFilt[ii].regulationStatus,
			arrPOGISFilt[ii].editor,
			renderStringArrayXL(arrPOGISFilt[ii].associations),
			renderStringArrayXL(arrPOGISFilt[ii].relatedDocuments),
			'',
			arrPOGISFilt[ii].docStatus,
		]);
		
		intRowCount++;

		const arrAttach = arrPOGISFilt[ii].pogisAttachments ?? [];
		arrAttach.forEach(iAttach => {
			intRowCount = renderRowItemAsLinkXL(
				intRowCount,
				iAttach.attachmentId,
				iAttach.file.uri,
				'G',
				5,
				sheet,
				table,
				t,
			);
		});
	}

	table.commit();
	const strZipName = strPageName;
	await createZIPXL(workbook, strZipName, t);
};
